import script from "./WaterDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaterDetail.vue?vue&type=script&setup=true&lang=ts"

import "./WaterDetail.vue?vue&type=style&index=0&id=38687b10&lang=sass"

const __exports__ = script;

export default __exports__